import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../images/imageUrls';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const getConnectLogoConfig = isMobile => {
  const url = isMobile ? imageUrls.connectMobileLogo : imageUrls.connectLogo;
  return {
    url,
    altText: 'Connect'
  };
};
export const ConnectLogo = () => {
  const {
    isMobile
  } = useResponsiveness();
  const {
    url,
    altText
  } = getConnectLogoConfig(isMobile);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UIImage, {
      alt: altText,
      height: 40,
      responsive: false,
      src: url
    })
  });
};